import React, { useContext, useEffect, useState } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import { Input, Button, Form, Spin, Select, App } from "antd";
import { FaPlus } from "react-icons/fa";
import { API, Enum, Regex } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios";

// Interfaces
import { AxiosError } from "../../../interfaces/axios"

const { Pages: { BasicInformation: { City: CityLanguage } }, Enum: EnumLanguage, Share, Validation, Message: MessageLanguage } = language
const { BASIC_INFORMATION_CITY_ID, BASIC_INFORMATION_CITY_CREATE, BASIC_INFORMATION_CITY_UPDATE, BASIC_INFORMATION_PROVINCE_ALL } = API
const { Message } = Enum

interface ProvinceType {
    id: string,
    name: string,
    publish: boolean,
    createdAt: Date,
    updatedAt: Date,
}
interface CityType {
    id: string,
    name: string,
    province: ProvinceType,
    publish: boolean,
    createdAt: Date,
    updatedAt: Date,
}

export default function CURecord() {

    const [form] = Form.useForm()
    const [, forceUpdate] = useState({})
    const navigate = useNavigate()
    const { axios } = useContext(AxiosContext)
    const [loadingRecord, setLoadingRecord] = useState<boolean>(true)
    const [loadingProvinces, setLoadingProvinces] = useState<boolean>(true)
    const [provinces, setProvinces] = useState<ProvinceType[]>([])
    const { id: cityId } = useParams()
    const { message } = App.useApp();

    useEffect(() => {
        // To disable submit button at the beginning.
        forceUpdate({})
        initialAPI().then(response => response)
    }, [])

    const initialAPI = async () => {
        await getProvinces()
        await getRecord()
    }

    const getProvinces = async () => axios.post(BASIC_INFORMATION_PROVINCE_ALL).then((response: { data: ProvinceType[] }) => {
        const { data: provinces } = response
        setProvinces(provinces)
        setLoadingProvinces(false)
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    })

    const getRecord = async () => cityId ? axios.get(BASIC_INFORMATION_CITY_ID + cityId).then((response: { data: CityType }) => {
        const { data: city } = response
        form.setFieldsValue({ ...city, province: city.province.id })
        setLoadingRecord(false)
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    }) : setLoadingRecord(false)

    const onFinish = ((city: {}) => {
        setLoadingRecord(true)
        if (cityId) {
            axios.patch(BASIC_INFORMATION_CITY_UPDATE + cityId, city).then((response: {}) => {
                message.success(MessageLanguage[Message.UPDATE_RECORD]).then(response => response)
                setLoadingRecord(false)
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        } else {
            axios.post(BASIC_INFORMATION_CITY_CREATE, city).then((response: { data: { id:number } }) => {
                message.success(MessageLanguage[Message.CREATE_RECORD]).then(response => response)
                const { data: { id } } = response
                navigate('/basic-information/city/edit/' + id)
                setLoadingRecord(false)
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        }
    })

    return (
        <Spin spinning={loadingRecord || loadingProvinces} tip={Share.loading} size="large">
            <Form form={form} name="cu-record" onFinish={onFinish} style={{ maxWidth: 400 }}>
                <Form.Item
                    label={CityLanguage.name}
                    name="name"
                    hasFeedback
                    rules={[
                        { required: true, message: `${CityLanguage.name} ${Validation.required}` },
                    ]}
                >
                    <Input placeholder={CityLanguage.name} />
                </Form.Item>
                <Form.Item
                    label={CityLanguage.province}
                    name="province"
                    hasFeedback
                    rules={[
                        { required: true, message: `${CityLanguage.province} ${Validation.required}` },
                    ]}
                >
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="label"
                        placeholder={Share.pleaseSelectedRecord}
                        options={provinces.map(({ id, name}) => ({ label: name, value: id}))}
                    />
                </Form.Item>
            <Form.Item shouldUpdate style={{marginTop:'30px'}}>
                {() => (
                    <Button
                        icon={<FaPlus />}
                        type="primary"
                        htmlType="submit"
                        block={true}
                        disabled={!form.getFieldValue('name') || !form.getFieldValue('province') || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
                    >
                        { Share.save }
                    </Button>
                )}
            </Form.Item>
        </Form>
        </Spin>
    )
}
